import React from 'react';
import Menu from '@material-ui/core/Menu';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {
  KabobMenuProvider,
  useKabobMenuContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu/KabobMenuContext';
import { DataValueMap, dataValueMapPropType } from 'Helpers/Testing';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';

// Deprecated: Put one in the design system
const KabobMenu = ({
  icon,
  test,
  children,
  dataValueMap,
}) => {
  const { anchorEl, setAnchorEl } = useKabobMenuContext();
  const open = Boolean(anchorEl);
  const handleClick = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    setAnchorEl(evt.currentTarget);
  };
  const handleClose = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    setAnchorEl(null);
  };
  const kabobId = `kabob-menu-${uuidv4()}`;
  const tooltipLabel = 'More';

  // If children is null then just return nothing
  if (children === null) {
    return null;
  }

  // If children is an array and only has null values then also just return
  if (Array.isArray(children) && children.filter((v) => { return !!v; }).length === 0) {
    return null;
  }

  return (
    <>
      <IconButton
        aria-describedby={kabobId}
        aria-label={tooltipLabel}
        test={test}
        title={tooltipLabel}
        {...dataValueMap.append(DataValueMap.keyMap.dataElementSemantic, 'kabob-menu').build()}
        onClick={handleClick}
        icon={icon}
      />
      <Menu
        id={kabobId}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        getContentAnchorEl={null}
      >
        {children}
      </Menu>
    </>
  );
};

KabobMenu.defaultProps = {
  test: null,
  children: [],
  dataValueMap: DataValueMap.init(),
  icon: MoreVertIcon,
};

KabobMenu.propTypes = {
  dataValueMap: dataValueMapPropType,
  test: PropTypes.string,
  icon: PropTypes.object,
  children: PropTypes.object,
};

const WithProvider = (props) => (
  <KabobMenuProvider>
    <KabobMenu {...props} />
  </KabobMenuProvider>
);

export default WithProvider;
